<template>
  <div class="cookie-banner" v-show="+cookieStatus !== 0">
    <i></i>
    <span>
      We use
      <NuxtLink to="https://sharkfoto.com/company/trust/privacy/" target="_blank">
        cookies
      </NuxtLink>
      to collect data to provide you a better experience on our website.
    </span>
    <el-icon @click="onHideCookieBanner"><Close /></el-icon>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { Close } from "@element-plus/icons-vue";
import { getCookieStatus, setCookieStatus } from "@/common/cookies";

const cookieStatus = ref(0);

function onHideCookieBanner() {
  cookieStatus.value = 0;
  setCookieStatus(0);
}

onMounted(() => {
  setTimeout(() => {
    let status = getCookieStatus();
    if (status === undefined || status === null) {
      setCookieStatus(1);
      status = 1;
    }
    cookieStatus.value = +status;
  }, 1000);
});
</script>

<style lang="scss" scoped>
.cookie-banner {
  box-sizing: border-box;
  position: fixed;
  bottom: 20px;
  left: 20px; /* 改为左下角 */
  transform: none; /* 移除水平居中 */
  padding: 20px 16px;
  display: flex;
  align-items: center;
  border-radius: 6px;
  background-color: #1c1d24;
  box-shadow: 0 6px 30px rgba(21, 21, 26, 0.4);
  width: max-content;
  max-width: calc(100% - 48px);
  z-index: 100;
  color: #b0b7cb;

  span {
    font-size: 13px;
  }

  a {
    color: $themeColor;
  }

  .el-icon {
    margin-left: 15px;
    font-size: 18px;
    cursor: pointer;
  }
}
</style>
